export default "https://assets.egbcdn.net/assets/packs/_/images/app/android/android-ru-1-08416724014ba41095192c19bea51c10.png";